(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-sport"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-by-sport').forEach(function (root) {
    var tabs = root.querySelectorAll('.shop-by-sport__tab');
    var panels = root.querySelectorAll('.shop-by-sport__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-hidden', panel.getAttribute('data-tab-panel') !== index);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
